var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "FileButton",
        _vm._b(
          {
            attrs: {
              label: "Upload PDB File",
              disabled: _vm.inSearch,
              loading: _vm.inSearch,
              "x-large": "",
              color: this.error ? "error" : "primary",
              accept:
                ".pdb,.mmcif,.cif,.mcif,chemical/x-pdb,chemical/x-cif,chemical/x-mmcif",
            },
            on: { upload: _vm.upload },
          },
          "FileButton",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _vm.error
        ? _c(
            "div",
            { staticStyle: { "margin-top": "12px", color: "#f44336" } },
            [_vm._v("\n    " + _vm._s(_vm.error) + "\n")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.inSearch && _vm.selectedChains
        ? _c("div", { staticStyle: { "margin-top": "12px" } }, [
            _vm._v(
              "\n   Searching similar predicted interfaces for Chain " +
                _vm._s(_vm.selectedChains[0]) +
                " and " +
                _vm._s(_vm.selectedChains[1]) +
                "\n"
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showChainSelection
        ? _c(
            "div",
            {
              staticStyle: {
                "margin-top": "12px",
                padding: "12px",
                border: "1px solid #e0e0e0",
                "border-radius": "4px",
                "background-color": "transparent",
                width: "fit-content",
                "margin-left": "auto",
                "margin-right": "auto",
              },
            },
            [
              _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                _vm._v("Select Chain Pair for Interface Search"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-wrap": "wrap",
                    gap: "8px",
                    width: "fit-content",
                    "max-width": "300px",
                    "max-height": "100px",
                    "overflow-y": "auto",
                  },
                },
                _vm._l(_vm.availableChainPairs, function (pair) {
                  return _c(
                    "button",
                    {
                      key: `${pair[0]}-${pair[1]}`,
                      style: {
                        padding: "6px 6px",
                        backgroundColor:
                          _vm.selectedChainPair === `${pair[0]},${pair[1]}`
                            ? "#1976D2"
                            : "#e0e0e0",
                        color:
                          _vm.selectedChainPair === `${pair[0]},${pair[1]}`
                            ? "white"
                            : "#333",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontWeight:
                          _vm.selectedChainPair === `${pair[0]},${pair[1]}`
                            ? "bold"
                            : "normal",
                      },
                      on: {
                        click: function ($event) {
                          _vm.selectedChainPair =
                            _vm.selectedChainPair === `${pair[0]},${pair[1]}`
                              ? ""
                              : `${pair[0]},${pair[1]}`
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(pair[0]) +
                          "-" +
                          _vm._s(pair[1]) +
                          "\n        "
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticStyle: {
                    "margin-top": "12px",
                    padding: "8px 16px",
                    "background-color": "#1976D2",
                    color: "white",
                    border: "none",
                    "border-radius": "4px",
                    cursor: "pointer",
                    "font-size": "14px",
                    width: "100%",
                  },
                  style: { opacity: _vm.selectedChainPair ? 1 : 0.5 },
                  attrs: { disabled: !_vm.selectedChainPair },
                  on: { click: _vm.confirmChainPair },
                },
                [_vm._v("\n        Search\n    ")]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }